import React, { useState, useEffect } from 'react';
import { db } from '../../../../firebase-config';
import { doc, getDoc, setDoc } from 'firebase/firestore';
import { Input, Button, Card, message as antMessage } from 'antd';

const ContactUsEditor = () => {
  const [mapLink, setMapLink] = useState('');
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    const fetchMapLink = async () => {
      setLoading(true);
      try {
        const docRef = doc(db, 'siteContent', 'contactus');
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
          setMapLink(docSnap.data().mapLink || '');
        } else {
          setMapLink('');
        }
      } catch (error) {
        antMessage.error('Failed to load map link.');
      }
      setLoading(false);
    };
    fetchMapLink();
  }, []);

  const handleMapLinkSave = async () => {
    setSaving(true);
    try {
      await setDoc(doc(db, 'siteContent', 'contactus'), { 
        mapLink: mapLink 
      });
      antMessage.success('Map link updated successfully!');
    } catch (error) {
      antMessage.error('Failed to save map link.');
    }
    setSaving(false);
  };

  return (
    <div style={{ maxWidth: 800, margin: '0 auto', padding: 24 }}>
      <h1 style={{ fontSize: '24px', fontWeight: 'bold', marginBottom: '24px' }}>Edit Contact Us Map Link</h1>
      
      {loading ? (
        <p>Loading...</p>
      ) : (
        <Card title="Map Link Settings">
          <p style={{ marginBottom: '16px', color: '#666' }}>
            Update the Google Maps embed link for the Contact Us page. 
            This will change only the map location displayed on the contact page.
          </p>
          <Input
            placeholder="Enter Google Maps embed URL (e.g., https://www.google.com/maps/embed?pb=...)"
            value={mapLink}
            onChange={(e) => setMapLink(e.target.value)}
            style={{ marginBottom: '16px' }}
          />
          <div style={{ display: 'flex', gap: '8px' }}>
            <Button 
              type="primary" 
              onClick={handleMapLinkSave} 
              loading={saving}
            >
              {saving ? 'Saving...' : 'Save Map Link'}
            </Button>
            <Button 
              onClick={() => setMapLink('')}
              disabled={saving}
            >
              Clear
            </Button>
          </div>
        </Card>
      )}
    </div>
  );
};

export default ContactUsEditor; 